import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  ProductOutlined,
  DesktopOutlined
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Menu, theme } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLogoutMutation } from '../../services/auth';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { setUser } from '../../redux/slices/user';
import BrandMark from '../../components/brand-mark';
const { Header, Sider, Content } = Layout;


const menuItem=[
    {
      key: '/device_management',
      icon: <DesktopOutlined />,
      label: 'Quản lý thiết bị',
    },
    {
      key: '/product_management',
      icon: <ProductOutlined />,
      label: 'Quản lý sản phẩm',
    },
    {
      key: '/user_management',
      icon: <UserOutlined />,
      label: 'Quản lý người dùng',
    },
  ]


  
const LayoutAdmin = (props: { content: any; }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { content } = props
  const [collapsed, setCollapsed] = useState(false);
  const [menuItemWithRole, setMenuItemWithRole] = useState(menuItem);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [logOut, { isLoading }] = useLogoutMutation();

  const user = useSelector((state: RootState) => state.user.user);

  React.useEffect(() => {
    if(user?.role === 1){
      setMenuItemWithRole(menuItem.filter((item) => item.key === "/device_management"));
    } else {
      setMenuItemWithRole(menuItem); // Nếu không phải role 1 thì reset lại menu đầy đủ
    }
  }, [user?.role]);

  React.useEffect(() => {
  const userData = localStorage.getItem('user');
  if (userData) {
    dispatch(setUser(JSON.parse(userData)));
  }
}, []);
  const onClickLogout = async() =>{
    const refreshToken = localStorage.getItem('refreshToken');
    await logOut({token: refreshToken}).unwrap();
    localStorage.removeItem('accessToken');
    navigate('/login')
  }
  const menu = {
    items: [
      { key: '1', label: 'Đăng xuất', onClick: () => onClickLogout() },
    ],
  };

  const getSelectedKeys = (pathname: string) => {
    if (pathname.startsWith('/product_management')) {
      return ['/product_management'];
    } else if (pathname.startsWith('/user_management')) {
      return ['/user_management'];
    } else if (pathname.startsWith('/device_management')) {
      return ['/device_management'];
    }
    return [];
  };

  return (
    <Layout >
      <Sider trigger={null} collapsible collapsed={collapsed} width={250}>
        <BrandMark variant="sidebar" />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={getSelectedKeys(location.pathname)}
          items={menuItemWithRole}
          defaultOpenKeys={["/device_management"]}
          onClick={({ key }) => {
            navigate(key)
          }}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            borderBottom: '1px solid var(--line)',
          }}
        >
          <div className="signal-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <div className="signal-header__user">
            <span className="signal-header__name">{user?.user_name}</span>
            <Dropdown menu={menu} trigger={['click']}>
              <Avatar
                size={32}
                style={{ cursor: 'pointer', background: 'var(--signal-soft)', color: 'var(--signal)' }}
                icon={<UserOutlined />}
              />
            </Dropdown>
          </div>
          </div>
        </Header>
        <Content
          style={{
            margin: '20px 16px',
            padding: 24,
            minHeight: '100vh',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {content}
        </Content>
      </Layout>
    </Layout>
  );
};
export default LayoutAdmin;